import { Switch } from "@/components/ui/switch";
import { cva } from "class-variance-authority";
import { type ReactElement, useId } from "react";

import type { LabeledSwitchProps } from "./types";

const labeledSwitchTrackVariants = cva(
  "duration-300 ease-in-out data-[state=unchecked]:bg-neutral-200 [&>span]:shadow-md [&>span]:duration-300 [&>span]:ease-in-out",
  {
    variants: {
      variant: {
        blue: "",
        red: "focus-visible:shadow-focus-danger data-[state=checked]:bg-destructive",
      },
    },
  }
);

export const LabeledSwitch = ({
  "aria-label": ariaLabel,
  checked,
  onCheckedChange,
  label,
  variant,
  disabled = false,
  disabledReason,
}: LabeledSwitchProps): ReactElement => {
  const switchId = useId();
  return (
    <div className="flex items-center gap-3" title={disabled ? disabledReason : undefined}>
      <Switch
        id={switchId}
        aria-label={ariaLabel}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className={labeledSwitchTrackVariants({ variant })}
      />
      <label
        htmlFor={switchId}
        className={
          disabled
            ? "cursor-not-allowed text-2xs font-semibold uppercase tracking-micro text-text-disabled"
            : "cursor-pointer text-2xs font-semibold uppercase tracking-micro text-neutral-500"
        }
      >
        {label}
      </label>
    </div>
  );
};
